(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-slider"] = factory();
	else
		root["vue-slider"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 477:
/***/ (function(module) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __nested_webpack_require_530__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_530__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_530__.o(definition, key) && !__nested_webpack_require_530__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_530__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__nested_webpack_require_530__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __nested_webpack_exports__ = {};

// EXPORTS
__nested_webpack_require_530__.d(__nested_webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_530__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueCurrencyInput.vue?vue&type=template&id=0c546259&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-currency-input",class:{ 'sf-currency-input--postfixed': _vm.postfix, 'sf-currency-input--error': _vm.hasError, 'sf-currency-input--focused': _vm.isFocused }},[(_vm.label)?_c('label',{attrs:{"id":_vm.uuid + '-label',"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"sf-currency-input__wrapper",style:({ maxWidth: _vm.maxWidthStyle })},[_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"currency-input",staticClass:"sf-currency-input__field",class:{ 'sr-only': _vm.$attrs['readonly'], 'sf-currency-input__field--error': _vm.hasError },style:({ paddingRight: _vm.paddingRight + 'px' }),attrs:{"id":_vm.uuid,"type":"tel","aria-invalid":_vm.hasError ? 'true' : false,"aria-labelledby":_vm.label ? _vm.uuid + '-label' : false,"aria-describedby":_vm.ariaDescribedBy ? _vm.ariaDescribedBy : false,"maxlength":_vm.maxLength},domProps:{"value":(_vm.model)},on:{"keyup":function($event){return _vm.formatString($event.target.value)},"focus":function($event){_vm.isFocused = true},"blur":function($event){_vm.isFocused = false},"input":function($event){if($event.target.composing)return;_vm.model=$event.target.value}}},'input',_vm.$attrs,false),_vm.inputListeners)),(_vm.$attrs['readonly'])?_c('span',{staticClass:"sf-currency-input__value",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.formatText(_vm.value))),(_vm.postfix)?[_vm._v(" ")]:_vm._e()],2):_vm._e(),(_vm.postfix)?_c('span',{staticClass:"sf-currency-input__postfix"},[_vm._v(_vm._s(_vm.postfix))]):_vm._e()]),(_vm.addon)?_c('i',{attrs:{"id":_vm.computedAddonId}},[_c('span',{staticClass:"sf-currency-input__addon"},[_vm._v(_vm._s(_vm.addon))])]):_vm._e()])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueCurrencyInput.vue?vue&type=script&lang=js&


const DELIMITERS = { en: [',', '\\.'], hu: [' ', ','] };
/* harmony default export */ const VueCurrencyInputvue_type_script_lang_js_ = ({
	mixins: [c, N, a],
	inheritAttrs: false,
	name: 'VueCurrencyInput',
	data: () => ({
		model: null,
		isFocused: false
	}),
	props: {
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		Text of the label
		*/
		label: {
			required: false,
			type: String
		},
		/**
		The maximum width of the input
		 */
		maxWidth: {
			type: Number
		},
		/**
		Full width on mobile
		*/
		fullWidthMobile: {
			type: Boolean
		},
		/**
		Native maxlength attribute of input
		 */
		maxLength: {
			type: Number
		},
		/**
		postfix text of the input
		 */
		postfix: {
			type: String,
			required: false
		},
		/**
		Grouping/formatting values with spaces (# ### ### ###)
		 */
		isGrouped: {
			type: Boolean,
			required: false,
			default: true
		},
		/**
		Number of allowed decimals
		 */
		decimals: {
			type: Number,
			required: false,
			default: 0
		},
		/**
		Add padding right in inline-style onto the input
		 */
		paddingRight: {
			type: Number,
			reqired: false,
			default: 0
		}
	},
	watch: {
		value: {
			handler(val) {
				if (val <= Number.MAX_SAFE_INTEGER) {
					this.formatNumber(val);
				}
			},
			immediate: true
		}
	},
	computed: {
		inputListeners() {
			return Object.assign({}, this.$listeners, {
				input() {
					return;
				}
			});
		},
		maxWidthStyle() {
			return this.fullWidthMobile && this.isMobile && this.maxWidth ? null : `${this.maxWidth}px`;
		}
	},
	methods: {
		formatString(value) {
			let regexp = new RegExp(`[^0-9${this.decimalDelimiter}]`, 'g');
			let parsedValue = (value + '').replace(regexp, '');
			const formattedValueMatch = parsedValue.match(new RegExp(`(\\d+)(${this.decimalDelimiter}?)(\\d{0,${this.decimals}})\\d*`));
			let formattedValue = '';
			if (formattedValueMatch) {
				if (formattedValueMatch[1] <= Number.MAX_SAFE_INTEGER) {
					formattedValue =
						new Intl.NumberFormat(this.$i18n.locale, {
							minimumFractionDigits: 0,
							maximumFractionDigits: this.decimals,
							useGrouping: this.isGrouped
						}).format(formattedValueMatch[1]) + `${formattedValueMatch[2]}${formattedValueMatch[3]}`;
					this.model = formattedValue;
					this.$emit('input', this.parse(value));
				} else {
					this.model = this.formatBigInt(formattedValueMatch[1]);
					this.$emit('input', formattedValueMatch[1]);
				}
			}
		},
		formatBigInt(bigInt) {
			let result = '';
			for (let i = bigInt.length - 1; i >= 0; i -= 3) {
				result = bigInt.substring(Math.max(i - 2, 0), i + 1) + (result && ' ' + result);
			}
			return result;
		},
		formatNumber(value) {
			let formattedValue = '';
			if (value || value === 0) {
				formattedValue = new Intl.NumberFormat(this.$i18n.locale, {
					minimumFractionDigits: 0,
					maximumFractionDigits: this.decimals,
					useGrouping: this.isGrouped
				}).format(value);
				if (Number.isNaN(formattedValue)) {
					formattedValue = '';
				}
			}
			this.model = formattedValue;
		},
		formatText(value) {
			return new Intl.NumberFormat(this.$i18n.locale, {
				minimumFractionDigits: 0,
				maximumFractionDigits: this.decimals,
				useGrouping: this.isGrouped
			}).format(value);
		},
		parse(value) {
			let regexp = new RegExp(`[^0-9${this.decimalDelimiter}]`, 'g');
			let regexpDelimiter = new RegExp(this.decimalDelimiter, 'g');
			let parsedValue = (value + '').replace(regexp, '').replace(regexpDelimiter, '.');
			let numericvalue = parseFloat(parsedValue);
			if (!isNaN(numericvalue)) {
				return Number.isInteger(numericvalue) ? numericvalue : +numericvalue.toFixed(this.decimals);
			} else {
				return null;
			}
		}
	},
	created() {
		let delimiter = DELIMITERS[this.$i18n.locale];
		this.thousandDelimiter = delimiter[0];
		this.decimalDelimiter = delimiter[1];
	}
});

;// CONCATENATED MODULE: ./src/components/VueCurrencyInput.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueCurrencyInputvue_type_script_lang_js_ = (VueCurrencyInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueCurrencyInput.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueCurrencyInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "0c546259",
  null
  
)

/* harmony default export */ const VueCurrencyInput = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueCurrencyInput);


__nested_webpack_exports__ = __nested_webpack_exports__["default"];
/******/ 	return __nested_webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-currency-input.umd.js.map

/***/ }),

/***/ 585:
/***/ ((module) => {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_187__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_187__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_187__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_187__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_187__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_187__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_187__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_187__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_187__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_187__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_187__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_187__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_187__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_187__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_187__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_187__(__nested_webpack_require_187__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __nested_webpack_require_3663__) {

"use strict";

var LIBRARY = __nested_webpack_require_3663__("2d00");
var $export = __nested_webpack_require_3663__("5ca1");
var redefine = __nested_webpack_require_3663__("2aba");
var hide = __nested_webpack_require_3663__("32e9");
var Iterators = __nested_webpack_require_3663__("84f2");
var $iterCreate = __nested_webpack_require_3663__("41a0");
var setToStringTag = __nested_webpack_require_3663__("7f20");
var getPrototypeOf = __nested_webpack_require_3663__("38fd");
var ITERATOR = __nested_webpack_require_3663__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __nested_webpack_require_6569__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __nested_webpack_require_6569__("ce10");
var enumBugKeys = __nested_webpack_require_6569__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __nested_webpack_require_6868__) {

var dP = __nested_webpack_require_6868__("86cc");
var anObject = __nested_webpack_require_6868__("cb7c");
var getKeys = __nested_webpack_require_6868__("0d58");

module.exports = __nested_webpack_require_6868__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __nested_webpack_require_7368__) {

var isObject = __nested_webpack_require_7368__("d3f4");
var document = __nested_webpack_require_7368__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __nested_webpack_require_7752__) {

var global = __nested_webpack_require_7752__("7726");
var hide = __nested_webpack_require_7752__("32e9");
var has = __nested_webpack_require_7752__("69a8");
var SRC = __nested_webpack_require_7752__("ca5a")('src');
var $toString = __nested_webpack_require_7752__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__nested_webpack_require_7752__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __nested_webpack_require_8926__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __nested_webpack_require_8926__("cb7c");
var dPs = __nested_webpack_require_8926__("1495");
var enumBugKeys = __nested_webpack_require_8926__("e11e");
var IE_PROTO = __nested_webpack_require_8926__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __nested_webpack_require_8926__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __nested_webpack_require_8926__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __nested_webpack_require_10537__) {

var store = __nested_webpack_require_10537__("5537")('wks');
var uid = __nested_webpack_require_10537__("ca5a");
var Symbol = __nested_webpack_require_10537__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __nested_webpack_require_11259__) {

var dP = __nested_webpack_require_11259__("86cc");
var createDesc = __nested_webpack_require_11259__("4630");
module.exports = __nested_webpack_require_11259__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __nested_webpack_require_11635__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __nested_webpack_require_11635__("69a8");
var toObject = __nested_webpack_require_11635__("4bf8");
var IE_PROTO = __nested_webpack_require_11635__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __nested_webpack_require_12229__) {

"use strict";

var create = __nested_webpack_require_12229__("2aeb");
var descriptor = __nested_webpack_require_12229__("4630");
var setToStringTag = __nested_webpack_require_12229__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__nested_webpack_require_12229__("32e9")(IteratorPrototype, __nested_webpack_require_12229__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __nested_webpack_require_13315__) {

// 7.1.13 ToObject(argument)
var defined = __nested_webpack_require_13315__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __nested_webpack_require_13537__) {

var core = __nested_webpack_require_13537__("8378");
var global = __nested_webpack_require_13537__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __nested_webpack_require_13537__("2d00") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __nested_webpack_require_14070__) {

var global = __nested_webpack_require_14070__("7726");
var core = __nested_webpack_require_14070__("8378");
var hide = __nested_webpack_require_14070__("32e9");
var redefine = __nested_webpack_require_14070__("2aba");
var ctx = __nested_webpack_require_14070__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __nested_webpack_require_15795__) {

var shared = __nested_webpack_require_15795__("5537")('keys');
var uid = __nested_webpack_require_15795__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __nested_webpack_require_16055__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __nested_webpack_require_16055__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __nested_webpack_require_16438__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __nested_webpack_require_16438__("626a");
var defined = __nested_webpack_require_16438__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __nested_webpack_require_16934__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __nested_webpack_require_16934__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __nested_webpack_require_18109__) {

var toInteger = __nested_webpack_require_18109__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __nested_webpack_require_18586__) {

var def = __nested_webpack_require_18586__("86cc").f;
var has = __nested_webpack_require_18586__("69a8");
var TAG = __nested_webpack_require_18586__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __nested_webpack_require_18956__) {

var dP = __nested_webpack_require_18956__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __nested_webpack_require_18956__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __nested_webpack_require_19671__) {

var anObject = __nested_webpack_require_19671__("cb7c");
var IE8_DOM_DEFINE = __nested_webpack_require_19671__("c69a");
var toPrimitive = __nested_webpack_require_19671__("6a99");
var dP = Object.defineProperty;

exports.f = __nested_webpack_require_19671__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __nested_webpack_require_20361__) {

// optional / simple context binding
var aFunction = __nested_webpack_require_20361__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __nested_webpack_require_20968__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __nested_webpack_require_20968__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __nested_webpack_require_20968__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __nested_webpack_require_21368__) {

// 7.1.15 ToLength
var toInteger = __nested_webpack_require_21368__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __nested_webpack_require_21670__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__nested_webpack_require_21670__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __nested_webpack_require_21946__) {

var $iterators = __nested_webpack_require_21946__("cadf");
var getKeys = __nested_webpack_require_21946__("0d58");
var redefine = __nested_webpack_require_21946__("2aba");
var global = __nested_webpack_require_21946__("7726");
var hide = __nested_webpack_require_21946__("32e9");
var Iterators = __nested_webpack_require_21946__("84f2");
var wks = __nested_webpack_require_21946__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __nested_webpack_require_24098__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __nested_webpack_require_24098__("6821");
var toLength = __nested_webpack_require_24098__("9def");
var toAbsoluteIndex = __nested_webpack_require_24098__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __nested_webpack_require_25109__) {

module.exports = !__nested_webpack_require_25109__("9e1e") && !__nested_webpack_require_25109__("79e5")(function () {
  return Object.defineProperty(__nested_webpack_require_25109__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __nested_webpack_require_25630__) {

"use strict";

var addToUnscopables = __nested_webpack_require_25630__("9c6c");
var step = __nested_webpack_require_25630__("d53b");
var Iterators = __nested_webpack_require_25630__("84f2");
var toIObject = __nested_webpack_require_25630__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __nested_webpack_require_25630__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __nested_webpack_require_26839__) {

var isObject = __nested_webpack_require_26839__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __nested_webpack_require_27081__) {

var has = __nested_webpack_require_27081__("69a8");
var toIObject = __nested_webpack_require_27081__("6821");
var arrayIndexOf = __nested_webpack_require_27081__("c366")(false);
var IE_PROTO = __nested_webpack_require_27081__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __nested_webpack_require_29712__) {

module.exports = __nested_webpack_require_29712__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __nested_webpack_require_29890__) {

var document = __nested_webpack_require_29890__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fae3":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_30094__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_30094__.r(__nested_webpack_exports__);

// EXPORTS
__nested_webpack_require_30094__.d(__nested_webpack_exports__, "longClickDirective", function() { return /* reexport */ longClickDirective; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __nested_webpack_require_30094__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __nested_webpack_require_30094__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __nested_webpack_require_30094__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __nested_webpack_require_30094__("7f7f");

// CONCATENATED MODULE: ./src/directives/longclick.js


/* harmony default export */ var longclick = (function (_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 400 : _ref$delay,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 50 : _ref$interval;
  return {
    bind: function bind(el, binding, vNode) {
      if (typeof binding.value !== 'function') {
        var compName = vNode.context.name;
        var warn = "[longclick:] provided expression '".concat(binding.expression, "' is not a function, but has to be");

        if (compName) {
          warn += "Found in component '".concat(compName, "' ");
        }

        console.warn(warn); // eslint-disable-line
      }

      var pressTimer = null;
      var pressInterval = null;

      var start = function start(e) {
        if (e.type === 'click' && e.button !== 0) {
          return;
        }

        if (pressTimer === null) {
          pressTimer = setTimeout(function () {
            if (interval && interval > 0) {
              pressInterval = setInterval(function () {
                handler();
              }, interval);
            }

            handler();
          }, delay);
        }
      }; // Cancel Timeout


      var cancel = function cancel() {
        if (pressTimer !== null) {
          clearTimeout(pressTimer);
          pressTimer = null;
        }

        if (pressInterval) {
          clearInterval(pressInterval);
          pressInterval = null;
        }
      }; // Run Function


      var handler = function handler(e) {
        binding.value(e);
      };

      ['mousedown', 'touchstart'].forEach(function (e) {
        return el.addEventListener(e, start);
      });
      ['click', 'mouseout', 'touchend', 'touchcancel'].forEach(function (e) {
        return el.addEventListener(e, cancel);
      });
    }
  };
});
// CONCATENATED MODULE: ./src/index.js

var longClickDirective = longclick;
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ })

/******/ });
//# sourceMappingURL=vue-long-click.common.js.map

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueSlider.vue?vue&type=template&id=f303344c&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-slider",class:{ 'sf-slider--webkit': _vm.isWebkit(), 'sf-slider--edge': _vm.isEdge(), 'sf-slider--limits-hidden': _vm.hideLimits }},[(_vm.isMobile)?_c('button',{directives:[{name:"long-click",rawName:"v-long-click",value:(() => _vm.decrementValue()),expression:"() => decrementValue()"}],staticClass:"sf-slider__step decrease",attrs:{"type":"button","disabled":_vm.value == _vm.sliderMin || _vm.$attrs['disabled']},on:{"click":_vm.decrementValue}},[_c('svg',{attrs:{"width":"10","height":"10","viewbox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9 5L1 5","stroke":"#52AE30","stroke-width":"2","stroke-linecap":"round"}})]),_c('span',{staticClass:"sr-only"},[_vm._v("Érték csökkentése")])]):_vm._e(),(!_vm.isMobile || (_vm.isMobile && _vm.mobileView == _vm.MOBILE_VIEWS.SLIDER))?[_c('div',{staticClass:"sf-slider__container",class:{ 'sf-slider__container--gray': _vm.trackGrayBackground }},[(this.isWebkit())?_c('div',{ref:"sliderProgress",staticClass:"sf-slider__progress"}):_vm._e(),(_vm.label)?_c('label',{staticClass:"sr-only",attrs:{"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',_vm._g(_vm._b({ref:"sliderInput",staticClass:"sf-slider__input",class:{ dragged: _vm.isGreaterThanZeroPercent },attrs:{"id":_vm.uuid,"type":"range","max":_vm.sliderMax,"min":_vm.sliderMin,"step":_vm.sliderStep},domProps:{"value":_vm.sliderValue}},'input',_vm.$attrs,false),_vm.inputListeners))]),(!_vm.hideLimits)?_c('div',{staticClass:"sf-slider__limits"},[_c('small',[_vm._v(_vm._s(_vm.sliderMinLabel))]),(_vm.bottomText)?_c('span',{staticClass:"sf-slider__value"},[_vm._v(_vm._s(_vm.bottomText))]):_vm._e(),_c('small',[_vm._v(_vm._s(_vm.sliderMaxLabel))])]):_vm._e()]:_vm._e(),(_vm.isMobile && _vm.mobileView == _vm.MOBILE_VIEWS.INPUT)?[_c('VueCurrencyInput',_vm._b({on:{"blur":_vm.handleInput},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}},'VueCurrencyInput',_vm.inputOptions,false))]:_vm._e(),(_vm.isMobile)?_c('button',{directives:[{name:"long-click",rawName:"v-long-click",value:(() => _vm.incrementValue()),expression:"() => incrementValue()"}],staticClass:"sf-slider__step increase",attrs:{"type":"button","disabled":_vm.value == _vm.sliderMax || _vm.$attrs['disabled']},on:{"click":_vm.incrementValue}},[_c('svg',{attrs:{"width":"10","height":"10","viewbox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 1V9","stroke":"#52AE30","stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M9 5L1 5","stroke":"#52AE30","stroke-width":"2","stroke-linecap":"round"}})]),_c('span',{staticClass:"sr-only"},[_vm._v("Érték növelése")])]):_vm._e()],2)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

// EXTERNAL MODULE: ../../node_modules/vue-long-click/dist/libs/vue-long-click.common.js
var vue_long_click_common = __webpack_require__(585);
// EXTERNAL MODULE: ../../node_modules/@ui-common/vue-currency-input/dist/vue-currency-input.umd.js
var vue_currency_input_umd = __webpack_require__(477);
var vue_currency_input_umd_default = /*#__PURE__*/__webpack_require__.n(vue_currency_input_umd);
;// CONCATENATED MODULE: ./src/components/constants.js
const MOBILE_VIEWS = {
	SLIDER: 'slider',
	INPUT: 'input'
};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueSlider.vue?vue&type=script&lang=js&







const longClick = (0,vue_long_click_common.longClickDirective)({ delay: 400, interval: 50 });
/* harmony default export */ const VueSlidervue_type_script_lang_js_ = ({
	name: 'VueSlider',
	inheritAttrs: false,
	mixins: [a, l],
	directives: {
		longClick
	},
	components: {
		VueCurrencyInput: (vue_currency_input_umd_default())
	},
	data: () => ({
		sliderValue: null,
		sliderMin: null,
		sliderMax: null,
		sliderMinLabel: null,
		sliderMaxLabel: null,
		sliderStep: null
	}),
	props: {
		/**
		 * The array given here becomes the value set of the input.
		 * Also the 'min', 'max' and 'step' attributes will be calculated from this array as well.
		 */
		data: {
			type: Array
		},
		/**
		 * Minimum value the input can have
		 */
		min: {
			type: Number
		},
		/**
		 * Maximum value the input can have
		 */
		max: {
			type: Number
		},
		/**
		 * The step attribute specifies the interval between legal numbers in the input.
		 * Example: if step="3", legal numbers could be -3, 0, 3, 6, etc.
		 * The step attribute can be used together with the 'max' and 'min' props to create a range of legal values.
		 */
		step: {
			type: Number
		},
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		 * Sets the text shown at the left end ot the input.
		 * If not set, the text shown will be the number given in the 'min' prop.
		 * If 'data' prop is given, the text shown will be the first (lowest) value in the 'data' array.
		 */
		minLabel: {
			type: String
		},
		/**
		 * Sets the text shown at the right end ot the input.
		 * If not set, the text shown will be the number given in the 'max' prop.
		 * If 'data' prop is given, the text shown will be the last (highest) value in the 'data' array.
		 */
		maxLabel: {
			type: String
		},
		/**
		 * Shows/hides the input limits
		 */
		hideLimits: {
			type: Boolean,
			default: false
		},
		/**
		 * Sets the background of the track grey.
		 * Can be seen on the start and the end of track line.
		 */
		trackGrayBackground: {
			type: Boolean,
			default: false
		},
		/**
		 * Label of the input
		 */
		label: {
			required: false,
			type: String
		},
		mobileView: {
			default: 'slider',
			validator(val) {
				return Object.values(MOBILE_VIEWS).includes(val);
			}
		},
		inputOptions: {
			required: false
		},
		bottomText: {
			type: String
		}
	},
	inject: {
		providedId: {
			default: null
		}
	},
	watch: {
		value: {
			handler() {
				if (this.data && this.data.length) {
					this.sliderValue = this.data.indexOf(this.value);
				} else {
					this.sliderValue = this.value;
				}
				this.$nextTick(() => {
					this.styleSlider();
				});
			},
			immediate: true
		},
		minMax: {
			handler() {
				this.setRangeSettings();
				this.$nextTick(() => {
					this.styleSlider();
				});
			},
			immediate: true
		},
		data: {
			handler() {
				this.setRangeSettings();
				this.$nextTick(() => {
					this.styleSlider();
				});
			},
			immediate: true
		},
		isMobile() {
			this.$nextTick(() => {
				this.styleSlider();
			});
		}
	},
	computed: {
		MOBILE_VIEWS: () => MOBILE_VIEWS,
		minMax() {
			return `${this.min}/${this.max}`;
		},
		sliderPercentage() {
			const currentValue = this.sliderValue - this.sliderMin;
			return (currentValue / (this.sliderMax - this.sliderMin)) * 100;
		},
		inputListeners() {
			const vm = this;
			return Object.assign({}, this.$listeners, {
				input(event) {
					// if data exists
					if (vm.data && vm.data.length) {
						vm.$emit('input', vm.data[event.target.value]);
					} else {
						// if min and max
						const numericValue = parseInt(event.target.value, 10);
						if (!Number.isNaN(numericValue)) {
							vm.$emit('input', numericValue);
						}
					}
				},
				change(event) {
					// if data exists
					if (vm.isExplorer()) {
						if (vm.data && vm.data.length) {
							vm.$emit('input', vm.data[event.target.value]);
						} else {
							// if min and max
							const numericValue = parseInt(event.target.value, 10);
							if (!Number.isNaN(numericValue)) {
								vm.$emit('input', numericValue);
							}
						}
					}
				}
			});
		},
		isGreaterThanZeroPercent() {
			return this.sliderPercentage > 0;
		}
	},
	methods: {
		handleInput(event) {
			let emitValue = parseInt(event.target.value.replace(/\s+/g, ''));
			if (emitValue > this.max) {
				emitValue = this.max;
				this.$emit('high-value');
			} else if (emitValue < this.min) {
				emitValue = this.min;
				this.$emit('low-value');
			}
			this.$emit('input', emitValue);
			this.$nextTick(() => {
				this.sliderValue = emitValue;
			});
		},
		styleSlider() {
			if (this.isWebkit && (!this.isMobile || (this.isMobile && this.mobileView == MOBILE_VIEWS.SLIDER))) {
				const progress = this.$refs.sliderProgress;
				progress.style.width = this.sliderPercentage + '%';
			}
		},
		isEdge() {
			return navigator.userAgent.indexOf('Edge') !== -1;
		},
		isExplorer() {
			return navigator.userAgent.indexOf('Trident') !== -1;
		},
		isWebkit() {
			return !this.isEdge() && navigator.userAgent.indexOf('AppleWebKit') !== -1;
		},
		setRangeSettings() {
			if (this.data && this.data.length) {
				this.sliderMin = 0;
				this.sliderMax = this.data.length - 1;
				this.sliderStep = 1;
				this.sliderValue = this.data.indexOf(this.value);
				this.sliderMinLabel = this.minLabel || this.data[0];
				this.sliderMaxLabel = this.maxLabel || this.data[this.data.length - 1];
			} else {
				this.sliderMin = this.min;
				this.sliderMax = this.max;
				this.sliderStep = this.step;
				this.sliderValue = this.value;
				this.sliderMinLabel = this.minLabel || this.min;
				this.sliderMaxLabel = this.maxLabel || this.max;
			}
		},
		incrementValue() {
			if (this.data && this.data.length) {
				if (this.value < this.data[this.sliderMax]) {
					const indexOfCurrent = this.data.indexOf(this.value);
					const value = this.data[indexOfCurrent + this.sliderStep];
					this.$emit('input', value);
				}
			} else {
				if (this.value < this.sliderMax) {
					const value = this.value + this.sliderStep <= this.sliderMax ? this.value + this.sliderStep : this.sliderMax;
					this.$emit('input', value);
				}
			}
		},
		decrementValue() {
			if (this.data && this.data.length) {
				if (this.value > this.data[this.sliderMin]) {
					const indexOfCurrent = this.data.indexOf(this.value);
					const value = this.data[indexOfCurrent - this.sliderStep];
					this.$emit('input', value);
				}
			} else {
				if (this.value > this.sliderMin) {
					const value = this.value - this.sliderStep >= this.sliderMin ? this.value - this.sliderStep : this.sliderMin;
					this.$emit('input', value);
				}
			}
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VueSlider.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueSlidervue_type_script_lang_js_ = (VueSlidervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-58.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueSlider.vue?vue&type=style&index=0&id=f303344c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueSlider.vue?vue&type=style&index=0&id=f303344c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueSlider.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueSlidervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "f303344c",
  null
  
)

/* harmony default export */ const VueSlider = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueSlider);


})();

__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-slider.umd.js.map